import Joi from 'joi';
import AddressPreference from '../enums/address-preference';
import PayloadTypeIndicator from '../enums/payload-type-indicator';
import ReviewAction from '../enums/review-action';
import TransactionType from '../enums/transaction-type';
import CustomInputData from './custom-input-data';
import PaymentOptions from './payment-options';
import ThreeDsInputData from './three-ds-input-data';
import TransactionAmount from './transaction-amount';

const DsaTransactionOptions = Joi.object().keys({
  checkoutDescription: Joi.string()
    .optional()
    .allow(''),
  consumerEmailAddressRequested: Joi.boolean().sensitive(false),
  consumerNameRequested: Joi.boolean().sensitive(false),
  consumerNationalIdentifierRequested: Joi.boolean().sensitive(false),
  consumerPhoneNumberRequested: Joi.boolean().sensitive(false),
  /*
  * The customInputData.dpaIntegrationType flag is deprecated
  * as of F20000 but per product do not want to error if it is passed like other init params.  This
  * is a special case and should be removed when updates to init
  * param strictness are implemented in upcoming feature
  */
  customInputData: CustomInputData,
  dpaAcceptedBillingCountries: Joi.array()
    .unique()
    .items(Joi.string().min(2))
    .allow(''),
  dpaAcceptedShippingCountries: Joi.array()
    .unique()
    .items(Joi.string().min(2))
    .allow(''),
  dpaBillingPreference: AddressPreference,
  dpaLocale: Joi.string()
    .optional()
    .allow(''),
  dpaShippingPreference: AddressPreference,
  merchantCategoryCode: Joi.string()
    .optional()
    .allow(''),
  merchantCountryCode: Joi.string()
    .optional()
    .allow(''),
  merchantOrderId: Joi.string()
    .optional()
    .allow(''),
  orderType: Joi.string()
    .optional()
    .allow(''),
  payloadTypeIndicator: PayloadTypeIndicator,
  paymentOptions: PaymentOptions,
  reviewAction: ReviewAction,
  threeDsInputData: ThreeDsInputData.optional().allow(''),
  threeDsPreference: Joi.string()
    .allow('')
    .optional(),
  transactionAmount: TransactionAmount,
  transactionType: TransactionType
});

export default DsaTransactionOptions;
